<template>
  <div>
    <base-header
      class="pb-9 pt-4"
      :type="$route.meta.headerClass ? $route.meta.headerClass : 'success'"
    >
      <div class="row">
        <div class="col">
          <div class="card mb-4 mt-3">
            <div class="card-body">
              <div class="row">
                <div class="col h3">
                  {{ col ? col.name : "Collection" }}
                </div>
                <div class="col-auto text-right">
                  <a class="btn btn-sm" :class="{ disabled: zipLoading }" @click="zipSigned()"
                    ><i class="fas fa-file-download mr-2"></i>{{ zipButtonLabel }}
                  </a>
                </div>
                <div class="col-auto text-right">
                  <base-button
                    type="secondary"
                    size="sm"
                    @click="renameCollection"
                  >
                    Rename
                  </base-button>
                </div>
                <div class="col-auto text-right">
                  <base-button
                    type="danger"
                    size="sm"
                    @click="confirmDeleteCollection"
                  >
                    Delete Collection
                  </base-button>
                </div>
                <div
                  class="col-auto text-right"
                  v-if="user.roles.archive_collections"
                >
                  <base-button
                    type="secondary"
                    icon
                    size="sm"
                    @click="uploadMode = true"
                  >
                    <span class="btn-inner--icon"
                      ><i class="fas fa-upload"></i
                    ></span>
                    <span class="btn-inner--text"
                      >Upload files to this Collection</span
                    >
                  </base-button>
                </div>

                <modal :show.sync="uploadMode" size="lg" modal-classes="modal">
                  <collection-uploader></collection-uploader>
                </modal>

              </div>
              <div class="row mb-2 mt-3">
                <div class="col-12">
                  <div class="card mb-0">
                    <div class="card-header py-2">
                      <button
                        type="button"
                        class="btn btn-link text-left w-100 p-0 d-flex align-items-center justify-content-between share-toggle-btn"
                        @click="shareSectionOpen = !shareSectionOpen"
                      >
                        <span class="h4 mb-0">Generate shareable link</span>
                        <i
                          class="fas"
                          :class="shareSectionOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
                        ></i>
                      </button>
                    </div>
                    <div class="card-body pb-2" v-if="shareSectionOpen">
                      <div class="row">
                        <div class="col-12 col-lg-4">
                          <base-input label="Public share expiry">
                            <input
                              class="form-control"
                              type="datetime-local"
                              v-model="shareExpiresAt"
                            />
                          </base-input>
                        </div>
                        <div class="col-12 col-lg-4">
                          <base-input label="Optional share password">
                            <input
                              class="form-control"
                              type="password"
                              v-model="sharePassword"
                              placeholder="Leave blank for no password"
                            />
                          </base-input>
                        </div>
                        <div class="col-12 col-lg-4 d-flex align-items-end mb-3">
                          <base-button
                            type="primary"
                            class="w-100"
                            :disabled="shareLoading"
                            @click="generateShareLink"
                          >
                            {{ shareLoading ? "Generating..." : "Generate share link" }}
                          </base-button>
                        </div>
                        <div class="col-12 mt-2" v-if="shareUrl">
                          <div class="input-group">
                            <input class="form-control" :value="shareUrl" readonly />
                            <div class="input-group-append">
                              <base-button type="secondary" @click="copyShareLink">
                                Copy
                              </base-button>
                            </div>
                          </div>
                          <small class="text-muted">
                            This public link allows unauthenticated access until the expiry above.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row mt-3">
                <div class="col h4">Restrictions</div>
              </div>
              <div class="row mt-3">
                <div class="col">
                  <base-input
                    label="Restrict to users who can access these departments"
                  >
                    <el-select
                      input-classes="form-control"
                      v-model="col.departmentAccess"
                      clearable
                      multiple
                      placeholder="Select Departments"
                      @change="changeField($event, 'departmentAccess')"
                    >
                      <el-option
                        v-for="prod in this.config.departments"
                        :key="prod"
                        :label="prod"
                        :value="prod"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                  <base-input
                    label="Restrict to users who can access these brands"
                  >
                    <el-select
                      input-classes="form-control"
                      v-model="col.brandAccess"
                      clearable
                      multiple
                      placeholder="Select Brands"
                      @change="changeField($event, 'brandAccess')"
                    >
                      <el-option
                        v-for="prod in this.config.brand"
                        :key="prod"
                        :label="prod"
                        :value="prod"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                  <base-input label="Restrict to specific users">
                    <el-select
                      input-classes="form-control"
                      v-model="col.userAccess"
                      clearable
                      multiple
                      placeholder="Select Users"
                      @change="changeField($event, 'usersAccess')"
                    >
                      <el-option
                        v-for="usr in this.users"
                        :key="usr.id"
                        :label="usr.name"
                        :value="usr.id"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--9" v-if="isLoaded">
      <ul class="list-group folders">
        <li class="list-group-item" v-for="group in groups" :key="group">
          <collection-group :groupName="group" :colId="col.id" :dels="groupedDels[group]">
          </collection-group>
        </li>
      </ul>
    </div>
    <div v-else>
      <loading-spinner></loading-spinner>
    </div>
  </div>
</template>
<script>
import CollectionGroup from "./Components/CollectionGroup";
import CollectionAssetUploader from "./Components/CollectionUploader";
import { Firebase } from "@/firebase";
import swal from "sweetalert2";
import { runZipJob } from "@/utils/zipJobs";

// style import
import "sweetalert2/dist/sweetalert2.css";

function defaultShareExpiryLocalValue() {
  const expiresAt = new Date();
  expiresAt.setFullYear(expiresAt.getFullYear() + 1);
  const tzOffsetMs = expiresAt.getTimezoneOffset() * 60000;
  return new Date(expiresAt.getTime() - tzOffsetMs).toISOString().slice(0, 16);
}

export default {
  name: "catalogue",
  components: {
    "collection-group": CollectionGroup,
    "collection-uploader": CollectionAssetUploader,
  },
  data() {
    return {
      uploadMode: false,
      shareSectionOpen: false,
      shareExpiresAt: defaultShareExpiryLocalValue(),
      sharePassword: "",
      shareUrl: "",
      shareLoading: false,
      zipLoading: false,
      zipProgress: 0,
      zipStage: "",
    };
  },
  computed: {
    config() {
      return this.$store.getters["config/config"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    users() {
      return this.$store.getters["users/users"];
    },
    isLoaded() {
      if (this.$store.getters["user/loading"]) {
        return false;
      } else {
        return true;
      }
    },
    col() {
      return this.$store.getters["collections/byId"](this.$route.params.id);
    },
    allProds() {
      return this.$store.getters["briefs/productions"];
    },
    dels() {
      return this.$store.getters["files/byColId"](this.$route.params.id);
    },
    archiveEvents() {
      return this.$store.getters["archiveEvents/byCollection"](this.$route.params.id);
    },
    folders() {
      if (this.deliverables) {
        let pA = this.deliverables;
        let arr = {};
        pA.forEach(function (entry) {
          if (entry.folderName) {
            arr[entry.folderName] = true;
          }
        });
        return Object.keys(arr);
      }
    },
    groupedDels() {
      function groupByKey(array, key) {
        return array.reduce((hash, obj) => {
          if (obj[key] === undefined) {
            return Object.assign(hash, {
              [obj[key]]: (hash[obj[key]] || []).concat(obj),
            });
          } else {
            return Object.assign(hash, {
              [obj[key]]: (hash[obj[key]] || []).concat(obj),
            });
          }
        }, {});
      }
      return groupByKey(this.deliverables, "folderName");
    },
    groups() {
      return Object.keys(this.groupedDels);
    },
    deliverables() {
      if (this.dels || this.archiveEvents) {
        let items = [];
        const files = this.dels || [];
        const events = this.archiveEvents || [];
        items = items.concat(
          files.map((file) => ({
            ...file,
            __kind: "file",
            folderName: file.folderName || "Uploads",
          }))
        );
        items = items.concat(
          events.map((event) => ({
            ...event,
            __kind: "archiveEvent",
            folderName: "Archive Clips",
          }))
        );

        items.sort((a, b) => {
          const aTs = a.updated_at || a.created_at || 0;
          const bTs = b.updated_at || b.created_at || 0;
          if (aTs > bTs) {
            return -1;
          }
          if (aTs < bTs) {
            return 1;
          }
          if (!aTs) {
            return -1;
          }
          return 0;
        });
        return items;
      } else {
        return [];
      }
    },
    departments() {
      if (this.departmentAccess) {
        return this.departmentAccess;
      } else {
        return this.config.departments;
      }
    },
    departmentAccess() {
      if (this.user.departmentAccess.length > 0) {
        return this.user.departmentAccess;
      } else {
        return null;
      }
    },
    types() {
      return this.config.delTypes;
    },
    brands() {
      if (this.brandAccess) {
        return this.brandAccess;
      } else {
        return this.config.brand;
      }
    },
    brandAccess() {
      if (this.user.brandAccess.length > 0) {
        return this.user.brandAccess;
      } else {
        return null;
      }
    },
    dimensions() {
      return this.config.formats;
    },
    partners() {
      return this.config.partners;
    },
    zipButtonLabel() {
      if (!this.zipLoading) return "Request Zip";
      if (this.zipProgress > 0) return `Building Zip (${this.zipProgress}%)`;
      if (this.zipStage) return `Building Zip (${this.zipStage})`;
      return "Requesting Zip";
    },
  },
  mounted() {
    this.$store.commit("user/setLoading", true);
    this.$store.dispatch("collections/fetchById", this.$route.params.id);
    this.$store.dispatch("files/openDBChannel", {
      where: [["colID", "==", this.$route.params.id]],
    });
    this.$store.dispatch("archiveEvents/openDBChannel", {
      where: [["collections", "array-contains", this.$route.params.id]],
    });
    this.$store.dispatch("users/fetchAndAdd", {
      limit: 0,
    });
    this.$store.commit("user/setLoading", false);
  },
  watch: {
    archiveEvents(events) {
      (events || []).forEach((event) => {
        if (!event || !event.clipFile) return;
        const file = this.$store.getters["files/fileById"](event.clipFile);
        if (!file) {
          this.$store.dispatch("files/fetchById", event.clipFile);
        }
      });
    },
  },
  methods: {
    // filterPersist() {
    //   localStorage.worklistDepartmentFilter = this.departmentFilter;
    // },
    async renameCollection() {
      if (!this.col) return;
      const result = await swal.fire({
        title: "Rename collection",
        input: "text",
        inputValue: this.col.name || "",
        inputPlaceholder: "Collection name",
        showCancelButton: true,
        confirmButtonColor: "#2dce89",
        cancelButtonColor: "#172b4d",
        confirmButtonText: "Save",
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return "Please enter a name";
          }
        },
      });
      if (!result.value) return;
      const name = result.value.trim();
      if (name === this.col.name) return;
      try {
        await this.$store.dispatch("collections/patch", {
          id: this.col.id,
          name,
        });
        swal.fire("Renamed!", "The collection has been renamed.", "success");
      } catch (error) {
        swal.fire(
          "Rename failed",
          (error && error.message) || "Could not rename collection.",
          "error"
        );
      }
    },
    confirmDeleteCollection() {
      swal
        .fire({
          title: "Delete collection?",
          text: `This will permanently delete "${this.col ? this.col.name : "this collection"}" and all files uploaded directly to this collection.`,
          type: "warning",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f5365c",
          cancelButtonColor: "#172b4d",
          confirmButtonText: "Yes, delete it.",
        })
        .then(async (result) => {
          if (!result.value) return;
          try {
            await this.$store.dispatch("collections/delete", this.col.id);
            swal.fire("Deleted!", "The collection has been deleted.", "success");
            this.$router.push("/collections");
          } catch (error) {
            swal.fire(
              "Delete failed",
              (error && error.message) || "Could not delete collection.",
              "error"
            );
          }
        });
    },
    async generateShareLink() {
      if (!this.shareExpiresAt) {
        this.$notify({
          type: "warning",
          title: "Expiry required",
          message: "Please choose when this public link should expire.",
        });
        return;
      }
      this.shareLoading = true;
      try {
        const createShare = Firebase.app()
          .functions("europe-west2")
          .httpsCallable("createCollectionShare");
        const result = await createShare({
          collectionId: this.col.id,
          expiresAt: new Date(this.shareExpiresAt).toISOString(),
          password: this.sharePassword || null,
        });
        const token = result && result.data && result.data.token;
        this.shareUrl = `${window.location.origin}/#/shared/collection/${token}`;
        this.$notify({
          type: "success",
          title: "Share link created",
          message: "Public collection link is ready to copy.",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Could not generate link",
          message: error && error.message ? error.message : "Unknown error",
        });
      } finally {
        this.shareLoading = false;
      }
    },
    async copyShareLink() {
      if (!this.shareUrl) return;
      try {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.shareUrl);
        } else {
          const input = document.createElement("input");
          input.value = this.shareUrl;
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        this.$notify({
          type: "success",
          title: "Copied",
          message: "Share URL copied to clipboard.",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Copy failed",
          message: "Please copy the URL manually.",
        });
      }
    },
    async zipSigned() {
      if (this.zipLoading) return;
      var files = [];

      var i;
      for (i = 0; i < this.deliverables.length; i++) {
        let item = this.deliverables[i];
        const fileId =
          item && item.__kind === "archiveEvent" ? item.clipFile : item && item.id;
        if (fileId) {
          const file = { id: fileId };
          file.folderName = item.folderName ? item.folderName : "";
          files.push(file);
        }
      }
      const result = await swal.fire({
        title: `Request a Zip of ${files.length} files?`,
        text: "This will create a zip containing all files in this collection.",
        type: "question",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f5365c",
        cancelButtonColor: "#172b4d",
        confirmButtonText: "Yes",
      });
      if (!result.value) return;

      const structure = files.reduce((acc, file) => {
        acc[file.id] = file.folderName || "";
        return acc;
      }, {});
      const fileIds = files.map((file) => file.id);
      const today = new Date().toISOString().slice(0, 10);

      this.zipLoading = true;
      this.zipProgress = 0;
      this.zipStage = "queued";
      try {
        await runZipJob({
          createPayload: {
            collectionId: this.col.id,
            fileIds,
            structure,
            zipFileName: `${this.col ? this.col.name : "Collection"} ${today}`,
            cacheKey: `collection:${this.col.id}:${fileIds.slice().sort().join(",")}`,
          },
          onCachedResult: async () => {
            const choice = await swal.fire({
              title: "Use existing ZIP?",
              text: "A recent ZIP already exists for this selection.",
              type: "question",
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Download cached",
              cancelButtonText: "Rebuild ZIP",
              reverseButtons: true,
            });
            return choice.value ? "use-cache" : "rebuild";
          },
          onProgress: ({ progress, stage }) => {
            this.zipProgress = typeof progress === "number" ? Math.max(0, Math.min(100, Math.round(progress))) : 0;
            this.zipStage = stage || "";
          },
        });
        this.$notify({
          type: "success",
          title: "Zip ready",
          message: "Your download has started.",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Zip failed",
          message: error && error.message ? error.message : "Could not build zip",
        });
      } finally {
        this.zipLoading = false;
      }
    },
    changeField(value, field) {
      var payload = {};
      payload.id = this.col.id;
      payload[field] = value;
      this.$store.dispatch("collections/patch", payload);
    },
  },
};
</script>
<style scoped>
.share-toggle-btn {
  color: #32325d;
  text-decoration: none;
}

.share-toggle-btn:hover,
.share-toggle-btn:focus {
  color: #32325d;
  text-decoration: none;
}

::v-deep .folders .card {
  background-color: #fff;
}
</style>